/**
 * Custom tracking: All Custom Tracking
 */
export const customTrackingEn = {
  customTracking: {
    banners: {
      importantMaintenance: 'This page is currently undergoing important maintenance. It will be available again soon.',
      customPhoneNumberExists: 'When \'Custom Phone Number\' exists, calls will be forwarded to that number.',
      leadNotificationsDisabled: 'Email lead notifications are currently turned off, please contact Rentsync Support to turn the notifications on.',
    },

    fields: {
      rentalListingSite: 'Rental Listing Site',
      customURL: 'Custom URL',
      customPhoneNumber: 'Custom Phone Number',
      customEmail: 'Custom Email',
    },

    fieldTooltips: {
      overrideOnRLS: 'This will override {trackingItem} on your rental listings.',
      viewWebsiteLinks: '\'View Company Website\' or \'View Website\' links',
      contactUsPhoneNumber: 'the \'Contact Us - Phone Number\' fields',
      contactUsEmail: 'the \'Contact Us - Email\' fields',
    },

    routingSettings: 'Routing settings are being managed via IVR.',
    viewEditCallFlows: 'To view or edit call flows for this property, go to IVR Settings.',
    viewIVR: 'View IVR',
    forwardingInstructions: 'This cannot be edited as it is controlled by call tracking settings. To edit where the call tracking number forwards to, first navigate to the call tracking details for {label} and toggle off “Forward to Property Phone Number”.',
    trackingNumber: 'Tracking Number',
    openNewTab: 'Open in a new tab',
    enterEmails: 'Enter emails',
    leadNotificationsDisabled: 'Email lead notifications are currently turned off, please contact Rentsync Support to turn the notifications on.',
    notApplicable: 'N/A',
    websiteURL: 'website.com',
  },
} as const;
export const customTrackingFr = {
  customTracking: {
    banners: {
      importantMaintenance: 'Cette page est actuellement en maintenance importante. Elle sera de nouveau accessible sous peu.',
      customPhoneNumberExists: 'S\'il existe un << numéro de téléphone personnalisé >>, les appels y seront transférés.',
      leadNotificationsDisabled: 'Les notifications de prospects par courriel sont actuellement désactivées, veuillez contacter le support Rentsync pour les activer.',
    },

    fields: {
      rentalListingSite: 'Site d\'annonces locatives',
      customURL: 'URL personnalisée',
      customPhoneNumber: 'Numéro de téléphone personnalisé',
      customEmail: 'Adresse courriel personnalisée',
    },

    fieldTooltips: {
      overrideOnRLS: 'Cela remplacera {trackingItem} dans vos annonces de location.',
      viewWebsiteLinks: 'les liens « Voir le site Web de l\'entreprise » ou « Voir le site Web »',
      contactUsPhoneNumber: 'les champs « Nous joindre - numéro de téléphone »',
      contactUsEmail: 'les champs « Nous joindre - courriel »',
    },

    routingSettings: 'Les paramètres de routage sont gérés dans la réponse vocale interactive (RVI).',
    viewEditCallFlows: 'Pour consulter ou modifier les flux d\'appels de cette propriété, accédez aux paramètres RVI.',
    viewIVR: 'Voir RVI',
    forwardingInstructions: 'Cette configuration ne peut pas être modifiée, car elle est contrôlée par les paramètres de suivi des appels. Pour changer la destination de transfert du numéro de suivi des appels, consultez les détails du suivi des appels pour {label}, puis désactivez « Transférer vers le numéro de téléphone de la propriété ».',
    trackingNumber: 'Numéro de suivi des appels',
    openNewTab: 'Ouvrir dans un nouvel onglet',
    enterEmails: 'Saisir des adresses courriel',
    leadNotificationsDisabled: 'Les notifications de prospects par courriel sont actuellement désactivées, veuillez contacter le support Rentsync pour les activer.',
    notApplicable: 'S.O.',
    websiteURL: 'siteweb.com',
  },
} as const;
